import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect, useState } from 'react';

// Vendored from usehooks-ts (useIsomorphicLayoutEffect), as in libs/components.
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

/**
 * `false` while rendering on the server and during hydration, `true` from the
 * first committed layout effect onwards.
 *
 * `useMediaQuery` seeds its server-side breakpoints from the request
 * User-Agent, so a desktop browser in a narrow window is served desktop-shaped
 * markup and repaints once hydration corrects it. Components that fork their
 * markup on a breakpoint use this to hold back the breakpoint-dependent branch
 * until the real viewport is known, rendering a CSS-gated placeholder instead.
 */
export const useIsMounted = () => {
  const $ = _c(2);
  const [isMounted, setIsMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useIsomorphicLayoutEffect(t0, t1);
  return isMounted;
};